import moment from 'moment'

export const mailManagement = {
    id: '',
    module: '',
    action: '',
    areaId: '',
    areaName: '',
    subject: '',
    body: '',
    footer: '',
}
export const mailManagementDetail = {
    id: '',
    mailManagementId: '',
    email: '',
    type: ''
}